module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmhd"
  }, [_c('i', [_c('b', [_vm._v("acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I would like to acknowledge all the great people at C&T Publishing for all the work they do with me. I also would like to acknowledge everyone at Shannon Fabrics, especially the sales and marketing people. They have been extremely helpful in providing supplies and inspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I also need to acknowledge the helpful staff that I have at the shop. They put in extra hours so that I could get this book done. Well done, ladies!")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2beed0be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Acknowledgment.vue
// module id = 66
// module chunks = 0